"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agentRepository = void 0;
const services_1 = require("@hc-frontend/services");
const utils_1 = require("@hc-frontend/utils");
const ramda_1 = require("ramda");
const toE164 = (0, ramda_1.pipe)(ramda_1.prop, utils_1.toPhoneE164);
const fromE164 = (0, ramda_1.pipe)(toE164, utils_1.fromPhoneE164);
const getParts = (0, ramda_1.pipe)(toE164, utils_1.getE164Parts);
const createAgent = (0, ramda_1.applySpec)({
    id: (0, ramda_1.prop)('agent_id'),
    firstName: (0, ramda_1.prop)('first_name'),
    lastName: (0, ramda_1.prop)('last_name'),
    phone: {
        number: (0, ramda_1.curry)(toE164)('phone'),
        cta: (0, ramda_1.curry)(fromE164)('phone'),
        parts: (0, ramda_1.curry)(getParts)('phone'),
        schedule: (0, ramda_1.always)(null),
        tty: (0, ramda_1.always)(null),
    },
    email: (0, ramda_1.prop)('email'),
    agency: {
        name: (0, ramda_1.prop)('agency_name'),
        id: (0, ramda_1.prop)('agency_id'),
    },
    fullName: (0, ramda_1.pipe)((0, ramda_1.props)(['first_name', 'last_name']), (0, ramda_1.join)(' ')),
    channel: (0, ramda_1.path)(['channel', 'channelName']),
    isTest: (0, ramda_1.prop)('is_test_agent'),
});
const agentRepository = {
    async fetchAgentInformation(agentId) {
        const response = await (0, services_1.fetchAgentInformationService)(agentId);
        const { data } = response !== null && response !== void 0 ? response : {};
        if ((0, utils_1.isDefined)(data))
            return createAgent(data);
        return null;
    },
};
exports.agentRepository = agentRepository;
//# sourceMappingURL=agent-repository.js.map